import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
import { Logo } from '../brand/Logo';
import { ButtonLink } from '../ui/ButtonLink';
import { discussSearchHref, legalNav, primaryNav } from '../../data/navigation';
import { services } from '../../data/services';
import { companyDescription } from '../../data/contact';
export function Footer() {
  const year = new Date().getFullYear();
  return <footer className="bg-navy-950 text-white" aria-labelledby="footer-heading" data-id="element-204" data-mp="pan01pbznrq">
      <h2 id="footer-heading" className="sr-only" data-id="element-205" data-mp="3s1vjoh3wqy8m">
        Site footer
      </h2>
      <div className="mx-auto max-w-7xl px-5 pb-10 pt-20 sm:px-8" data-id="element-206" data-mp="3n2srhx910mi2">
        <div className="grid gap-12 lg:grid-cols-12" data-id="element-207" data-mp="3j1z372ro95on">
          <div className="lg:col-span-4" data-id="element-208" data-mp="3j3jwkp292ikx">
            <Link to="/" aria-label="Avenqor Talent Search — Home" className="inline-block" data-id="element-209" data-mp="3e2w562a3zzq6">
              <Logo tone="light" data-id="element-210" data-mp="393t0iiy1jviq" />
            </Link>
            <p className="mt-6 max-w-sm text-[15px] leading-relaxed text-white/65" data-id="element-211" data-mp="39542cd7xet77">{companyDescription}</p>
          </div>

          <nav aria-label="Footer navigation" className="lg:col-span-2" data-id="element-212" data-mp="2kbtgunp37yi1">
            <h3 className="text-xs font-semibold uppercase tracking-[0.18em] text-gold" data-id="element-213" data-mp="2p4mpvnrl9szx">Navigate</h3>
            <ul className="mt-5 space-y-3" data-id="element-214" data-mp="2bdpw3tlxf5ra">
              {primaryNav.map(item => <li key={item.to} data-id="element-215" data-mp="2gckp1odlyap4">
                  <Link to={item.to} className="text-sm text-white/70 transition-colors duration-150 ease-out hover:text-white" data-id="element-216" data-mp="2g9f1weojhiw1">
                    {item.label}
                  </Link>
                </li>)}
            </ul>
          </nav>

          <nav aria-label="Services" className="lg:col-span-3" data-id="element-217" data-mp="2u5ab1st4zfm8">
            <h3 className="text-xs font-semibold uppercase tracking-[0.18em] text-gold" data-id="element-218" data-mp="2z0fwkqimms9s">Services</h3>
            <ul className="mt-5 space-y-3" data-id="element-219" data-mp="1im6ay45rrhmn">
              {services.map(service => <li key={service.id} data-id="element-220" data-mp="1nnn7xol4ujxy">
                  <Link to={`/services#${service.id}`} className="text-sm text-white/70 transition-colors duration-150 ease-out hover:text-white" data-id="element-221" data-mp="1nkhl6fzz7u5e">
                    {service.title}
                  </Link>
                </li>)}
            </ul>
          </nav>

          <div className="lg:col-span-3" data-id="element-222" data-mp="pu4fw2vsg271">
            <h3 className="text-xs font-semibold uppercase tracking-[0.18em] text-gold" data-id="element-223" data-mp="pt2t515etr9h">Start a Conversation</h3>
            <p className="mt-5 text-sm leading-relaxed text-white/65" data-id="element-224" data-mp="krvimubvudz4">
              Planning a senior appointment or exploring your next step? Begin with a confidential inquiry.
            </p>
            <ButtonLink to={discussSearchHref} variant="gold" className="mt-6 h-11 px-5 text-sm" data-id="element-225" data-mp="bvnzfk84ixbp">
              Discuss a Search
            </ButtonLink>
            <Link to="/our-team" className="mt-5 flex w-fit items-center gap-2 text-sm text-white/75 transition-colors duration-150 ease-out hover:text-gold" data-id="element-226" data-mp="266jgzc1admqm">
              Meet Our Team
              <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-227" data-mp="28rqvzo6x1zow" />
            </Link>
          </div>
        </div>

        <div className="mt-16 flex flex-col gap-4 border-t border-white/10 pt-8 text-sm text-white/55 sm:flex-row sm:items-center sm:justify-between" data-id="element-228" data-mp="2dor2u1blb6h2">
          <p data-id="element-229" data-mp="2nfvg8wlmaj9s">© {year} Avenqor Talent Search. All rights reserved.</p>
          <ul className="flex gap-6" data-id="element-230" data-mp="1ptekvwwg2fqo">
            {legalNav.map(item => <li key={item.to} data-id="element-231" data-mp="1pvhl19rb9p94">
                <Link to={item.to} className="transition-colors duration-150 ease-out hover:text-white" data-id="element-232" data-mp="1urpz0jtrvcep">
                  {item.label}
                </Link>
              </li>)}
          </ul>
        </div>
      </div>
    </footer>;
}